// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","pb2":"Cards_pb2__2q_5K","infected":"Cards_infected__-adYp","recovered":"Cards_recovered__1aizD","deaths":"Cards_deaths__Qdjzq"};